

import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../api/useGet';
import { GetSidebarByUser, GetSidebarByUserResponse } from '@/api/dtos';

const getData = (response?: SWRResponse<GetSidebarByUserResponse, GetSidebarByUserResponse>) => response?.data?.sidebar;
const getError = (response?: SWRResponse<GetSidebarByUserResponse, GetSidebarByUserResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useSidebarByUser = (configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {

        return () => {
            return new GetSidebarByUser({ });
        }
    }, []);

    return useGet(request, { getData, getError }, configuration);
}

export default useSidebarByUser;